export { fromEvent } from './file-selector';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/TheMedPortal Pharmacy-PHML/Code/Upgrade Staging code/medportal/node_modules/file-selector/dist/es5/index.js
// module id = 5840
// module chunks = 0